<script setup lang="ts">
import Button from 'primevue/button';

interface Props {
  isSortByName?: boolean;
  isSortBySinglePrice?: boolean;
  isSortByDoublePrice?: boolean;
}
defineProps<Props>();

const emits = defineEmits<{
  handleSortByName: [];
  handleSortBySinglePrice: [];
  handleSortByDoublePrice: [];
}>();

const handleSortByName = () => {
  emits('handleSortByName');
};

const handleSortBySinglePrice = () => {
  emits('handleSortBySinglePrice');
};

const handleSortByDoublePrice = () => {
  emits('handleSortByDoublePrice');
};
</script>
<template>
  <div class="mt-2 w-full flex gap-2 justify-content-end">
    <Button id="name-sort-btn" severity="secondary" :class="[`surface-border border-2 ${isSortByName ? 'surface-200' : 'surface-card '}`]" text :label="`${$t('management.tour.tour_name')} (A-Z)`" @click="handleSortByName()" />
    <Button
      id="single-price-sort-btn"
      severity="secondary"
      :class="[`surface-border border-2 ${isSortBySinglePrice ? 'surface-200' : 'surface-card '}`]"
      text
      :label="`${$t('common.buttons.sort_single')} (${$t('common.buttons.low_high')})`"
      @click="handleSortBySinglePrice()"
    />
    <Button
      id="double-price-sort-btn"
      severity="secondary"
      :class="[`surface-border border-2 ${isSortByDoublePrice ? 'surface-200' : 'surface-card '}`]"
      text
      :label="`${$t('common.buttons.sort_double')} (${$t('common.buttons.low_high')})`"
      @click="handleSortByDoublePrice()"
    />
  </div>
</template>
